import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { isHyphenatedLocale, LocaleContext } from '../../locale/i18n'
import { staticPagePaths } from '../../locale/pathing'
import { toDateString } from '../../logic/dateTime'
import { IContentfulBlogPost } from '../../logic/shared-types'
import { StaticPage } from '../../logic/staticPage'
import MeasurImage from '../MeasurImage'

import './BlogPostPreview.scss'

const BlogPostPreview = ({
  author,
  description,
  heroImageThumbnail,
  slug,
  title,
  createdAt,
}: Pick<
  IContentfulBlogPost,
  | 'author'
  | 'description'
  | 'heroImageThumbnail'
  | 'slug'
  | 'title'
  | 'createdAt'
>) => {
  const { locale, t } = useContext(LocaleContext)
  return (
    <Link
      className="blogPostPreview"
      to={[staticPagePaths[StaticPage.BLOG][locale], slug].join('') + '/'}
    >
      <div className="blogPostPreview__content">
        <div className="blogPostPreview__leftColumn">
          {author ? (
            <div className="blogPostPreview__author">
              <div className="blogPostPreview__authorBasics">
                {author.avatar20 ? (
                  <MeasurImage
                    className="blogPostPreview__authorImage"
                    image={author.avatar20.gatsbyImageData}
                    alt={author.name}
                  />
                ) : (
                  <img
                    className="h-5 w-5"
                    src="/avatar-placeholder.svg"
                    loading="lazy"
                    alt={author.name}
                  />
                )}
                {author.name}
              </div>
              <p>{toDateString(createdAt, locale)}</p>
            </div>
          ) : null}
          <h3
            className={classNames('blogPostPreview__title', {
              hyphenate: isHyphenatedLocale(),
            })}
          >
            {title}
          </h3>
          <p className="blogPostPreview__description">
            {description?.description}
          </p>
          <p>
            <span className="blogPostPreview__readMore">
              {t('common.keepReading')} &gt;
            </span>
          </p>
        </div>
        <div className="blogPostPreview__rightColumn">
          {heroImageThumbnail && (
            <div className="blogPostPreview__thumbnailContainer tintContainer">
              <MeasurImage
                alt={title}
                className="blogPostPreview__thumbnail"
                image={heroImageThumbnail.gatsbyImageData}
              />
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}

export default BlogPostPreview
